export default "__VITE_ASSET__DHOxZ7Bk__"